


export const AppName = () => {

    const name = process.env.REACT_APP_NAME || "";

    return <> {name?.replace("-", " ")}  </>
} 